import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { extractDate } from "../../../Components/Functions/date.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { BsExclamationTriangleFill, BsCheck2Square } from "react-icons/bs";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import { FcEngineering } from "react-icons/fc";


const ViewMaterialList = () => {
  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState();
  const [userData, setUserData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [hydrponicType, setHydrponicType] = useState();
  let { id } = useParams();
  const navigate = useNavigate();
    const [currentInventoryData, setCurrentInventoryData] = useState([]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/materialPlanning/get-hm-list/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setListData(res.data);
          setHydrponicType(res.data?.hydroponicType);
        } else {
          Toast("error", "Error while getting Lead!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/materialPlanning/getAllMaterialList`)
      .then((res) => {
        if (res.status === 200) {
          setCurrentInventoryData(res?.data?.MaterialList);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = () => {
    if (listData) {
      navigate(`/new-material-planning-list/table/${id}`);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }



  const getPrice = (inStock, costperUnit, weight, unit) => {
    const weightNew = parseFloat(weight);

    // if weight is a valid number > 0 and unit is among the specified ones, calculate with weight
    if (
      (unit === "kg" ||
        unit === "grams" ||
        unit === "ltr" ||
        unit === "ml" ||
        unit === "mtr") &&
      !isNaN(weightNew) &&
      weightNew > 0
    ) {
      return weightNew * costperUnit * inStock;
    }

    // fallback if weight is missing or 0
    return costperUnit * inStock;
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcEngineering className="fs-2 me-1" />
                  View Material List
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <h2 className="page-title m-0 text-capitalize p-4 d-block d-md-none d-lg-none">
              {listData?.project} : Material List-
              <span className="text-capitalize">{hydrponicType}</span>{" "}
              {`(${listData?.length} length * ${listData?.width} width)`}
            </h2>
            <div className="card-header d-flex justify-content-between align-items-center ">
              <h2 className="page-title m-0 text-capitalize d-none d-md-block d-lg-block">
                {listData?.project} : Material List-
                <span className="text-capitalize">{hydrponicType}</span>{" "}
                {`(${listData?.length} length * ${listData?.width} width)`}
              </h2>

              <div className="btn-list d-flex">
                <button
                  className="btn btn-primary mx-1 mt-2"
                  onClick={() => handleSubmit()}
                >
                  PRINT PDF
                </button>

                {/* <SimpleButton
                  buttonText="Edit Material Planning"
                  href={`/edit-material-planning-list/${id}`}
                /> */}
                <button
                  className="btn mx-1 mt-2 btn-primary text-white"
                  disabled={listData?.listType === "combinedList"}
                >
                  <a
                    href={`/edit-material-planning-list/${id}`}
                    style={{ textDecoration: "none", color: "white" }}
                  >
                    EDIT MATERIAL PLANNING
                  </a>
                </button>

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>

            <div className="card-body row">
              <div className="col-md border-end">
                {listData && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Name :</label>
                    <div className="w-100 col">
                      {(listData?.project || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {listData && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Length :</label>
                    <div className="w-100 col">
                      {(listData?.length || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {listData && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">Width :</label>
                    <div className="w-100 col">
                      {(listData?.width || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {listData && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Vehical Number :
                    </label>
                    <div className="w-100 col">
                      {(listData?.vehicalNum || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
                {listData && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Hydroponc Type :
                    </label>
                    <div className="w-100 col">
                      {(listData?.hydroponicType || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}

                {listData?.flatBedPercent && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      FlatBed Percent :
                    </label>
                    <div className="w-100 col">
                      {(listData?.flatBedPercent || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}

                {listData?.growBagPercent && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      GrowBag Percent :
                    </label>
                    <div className="w-100 col">
                      {(listData?.growBagPercent || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}

                {listData?.uniqueNum && (
                  <div className="mb-3 row">
                    <label className="w-25 form-label col">
                      Material List Number :
                    </label>
                    <div className="w-100 col">
                      {(listData?.uniqueNum || "N/A").toUpperCase()}
                    </div>
                  </div>
                )}
              </div>
              <hr className="m-0 p-0"></hr>
              <h2 className="mt-2">Material List : </h2>
              <hr></hr>
              <div className="col-lg-12 col-md-12">
                <div className="table-responsive">
                  <table className="table table-vcenter w-100 border">
                    <thead>
                      <tr>
                        <th style={{ minWidth: "150px" }}>Sr/ HSN/ Image</th>
                        <th style={{ minWidth: "170px" }}>
                          ITEM /SKU/ Weight/ Formula
                        </th>
                        <th style={{ minWidth: "200px" }}>Specifications</th>
                        <th>In stock / Count / Price</th>
                      </tr>
                    </thead>

                    <tbody>
                      {listData?.materialList
                        ?.filter((item) => item?.count)
                        .map((item, index) => {
                          const specialSkus = [
                            "MAT-CEA-FLA-FOG-GRO-00042",
                            "MAT-GRB-00081",
                          ];

                          const totalCount = specialSkus.includes(item?.sku)
                            ? item?.countGrow || 0
                            : (item?.countFlat || 0) + (item?.countGrow || 0);

                          return (
                            <tr
                              key={index}
                              style={{
                                backgroundColor:
                                  Number(item.count) > Number(item.inStock)
                                    ? "#ffcccc"
                                    : "transparent",
                              }}
                            >
                              {/* Column 1 */}
                              <td>
                                <img
                                  src={item?.image}
                                  alt={item?.item}
                                  width="150"
                                  height="150"
                                  className="m-0 mt-1 mb-1"
                                  style={{ borderRadius: "8px" }}
                                />
                                <br />
                                <span className="me-1">{index + 1}.</span>
                                {item?.hsn && (
                                  <span className="fs-5">
                                    <b>HSN: {item?.hsn}</b>
                                  </span>
                                )}
                              </td>

                              {/* Column 2 */}
                              <td>
                                <span className="fs-5">{item?.item}</span>
                                <br />
                                <b>SKU : {item?.sku}</b>

                                {item?.weight && (
                                  <>
                                    <br />
                                    <b>
                                      Weight : {item?.weight} {item?.proUnit}
                                    </b>
                                  </>
                                )}

                                {item?.formula && (
                                  <>
                                    <br />
                                    <b>Formula : {item?.formula}</b>
                                  </>
                                )}

                                {item?.flatFormul && (
                                  <>
                                    <br />
                                    <b>Formula : {item?.flatFormul}</b>
                                  </>
                                )}

                                {item?.mergeType && (
                                  <>
                                    <br />
                                    <b>Available in : {item?.mergeType}</b>
                                  </>
                                )}

                                {(item?.countFlat || item?.countGrow) && (
                                  <>
                                    <br />
                                    <b>
                                      Flatbed Count : {item?.countFlat || "0"}
                                      {item?.unit}
                                    </b>
                                    <br />
                                    <b>
                                      Growbags Count : {item?.countGrow || "0"}
                                      {item?.unit}
                                    </b>
                                    <hr className="p-0 m-1" />
                                    <b>
                                      Total Count : {totalCount}
                                      {item?.unit}
                                    </b>
                                  </>
                                )}
                              </td>

                              {/* Column 3 */}
                              <td className="fs-5">
                                {item?.specificationsNew?.length
                                  ? [
                                      ...new Map(
                                        item.specificationsNew
                                          .filter(
                                            (spec) =>
                                              (hydrponicType === "cea-nvph" &&
                                                spec?.type === "cea") ||
                                              hydrponicType === spec?.type ||
                                              (hydrponicType ===
                                                "hydroponicsOnly" &&
                                                (spec?.type === "flatbed" ||
                                                  spec?.type === "growbags"))
                                          )
                                          .map((spec) => [
                                            spec?.specification,
                                            spec,
                                          ])
                                      ).values(),
                                    ].map((spec, i) => (
                                      <div key={i}>{spec?.specification}</div>
                                    ))
                                  : "N/A"}

                                <br className="m-0 p-0"></br>
                                {item?.brandName && (
                                  <p className="m-0 badge bg-green-lt">
                                    Brand Name: {item?.brandName}
                                  </p>
                                )}
                              </td>

                              {/* Column 4 */}
                              <td style={{ width: "120px" }}>
                                <span className="fs-3">
                                  <b>
                                    Count :{" "}
                                    {["MAT-CEA-FLA-FOG-GRO-00042"].includes(
                                      item?.sku
                                    ) && hydrponicType === "hydroponicsOnly"
                                      ? item?.countGrow || 0
                                      : item?.count || 0}
                                    {item?.unit || "N/A"}
                                    <span>
                                      {item?.countKg
                                        ? ` / ${item?.countKg}kg`
                                        : ""}
                                    </span>
                                  </b>
                                </span>
                                <hr className="m-1" />
                                <b>
                                  In Stock :{" "}
                                  {Number(
                                    currentInventoryData.find(
                                      (inv) => inv.sku === item.sku
                                    )?.inStock || 0
                                  )}
                                </b>
                                <hr className="m-1" />
                                <b>Cost/Unit : {roundOffCost(item?.cost)}</b>
                                <hr className="m-1" />
                                <b>
                                  Total :
                                  {roundOffCost(
                                    getPrice(
                                      item?.count,
                                      item?.cost,
                                      item?.weight,
                                      item?.proUnit
                                    )
                                  )}
                                </b>
                              </td>
                            </tr>
                          );
                        })}

                      {/* ✅ Fixed Total Row */}
                      <tr>
                        <td colSpan="3" className="text-end fw-bold fs-4">
                          Total Cost:
                        </td>
                        <td className="fw-bold fs-4">
                          {roundOffCost(
                            listData?.materialList?.reduce(
                              (acc, item) =>
                                acc +
                                (getPrice(
                                  item?.count,
                                  item?.cost,
                                  item?.weight,
                                  item?.proUnit
                                ) || 0),
                              0
                            )
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewMaterialList;
